import { createFileRoute } from "@tanstack/react-router";
import { AnalyticsPage } from "@/routes/_main/exams/$slug/analytics";

export const Route = createFileRoute("/_main/groups/$gid/exams/$slug/analytics")({
  component: AnalyticsPage,
});
